<template>
  <section class="team section">
    <div class="container mx-auto">
      <!-- TITLE -->
      <h2 class="team_title h2 mb-[50px] text-center lg:text-left">
        Our Team
      </h2>
      <!-- SWIPER -->
      <div class="team_slider swiper min-h-[400px]">
        <div class="swiper-wrapper">
          <!-- Slide1 -->
          <div class="swiper-slide">
            <div class="flex flex-col md:flex-row gap-9">
              <!-- ITEM 1-->
              <div class="flex-1 flex flex-col lg:flex-row">
                <div class="flex flex-col lg:flex-row items-center gap-[30px]">
                  <!-- IMG -->
                  <div class="flex-1 rounded-lg">
                    <img src="../assets/img/doctor2.jpg" class="rounded-lg" alt="doc2">
                  </div>
                  <!-- INFO -->
                  <div class="flex-1 flex flex-col">
                    <!-- NAME -->
                    <h4 class="h4 mb-[10px]">MD. Jane McCarthy</h4>
                    <!-- JOB -->
                    <div class="font-medium uppercase tracking-[2.24px] 
                      text-[#9ab4b7] mb-[20px]">Surgeon</div>
                    <!-- DESCRIPTION -->
                    <p class="font-light mb-[26px] max-2-[320px]">
                      Skilled surgeon specializing in precision procedures, dedicated to exceptional patient care and recovery  
                    </p>
                    <!-- SOCIAL -->
                    <div class="flex items-center text-[30px] gap-x-5 text-accent-tertiary">
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-youtube-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-facebook-circle-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-instagram-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-pinterest-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ITEM 2-->
              <div class="flex-1 flex flex-col lg:flex-row">
                <div class="flex flex-col lg:flex-row items-center gap-[30px]">
                  <!-- IMG -->
                  <div class="flex-1">
                    <img src="../assets/img/doctor1.jpg" alt="">
                  </div>
                  <!-- INFO -->
                  <div class="flex-1 flex flex-col">
                    <!-- NAME -->
                    <h4 class="h4 mb-[10px]">Dr. Tom Park</h4>
                    <!-- JOB -->
                    <div class="font-medium uppercase tracking-[2.24px] 
                      text-[#9ab4b7] mb-[20px]">Plastic Surgeon</div>
                    <!-- DESCRIPTION -->
                    <p class="font-light mb-[26px] max-2-[320px]">
                      Expert plastic surgeon specializing in aesthetic and reconstructive procedures, committed to enhancing patient confidence and results.  
                    </p>
                    <!-- SOCIAL -->
                    <div class="flex items-center text-[30px] gap-x-5 text-accent-tertiary">
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-youtube-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-facebook-circle-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-instagram-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-pinterest-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Slide2 -->
          <div class="swiper-slide">
            <div class="flex flex-col md:flex-row gap-9">
              <!-- ITEM 1-->
              <div class="flex-1 flex flex-col lg:flex-row">
                <div class="flex flex-col lg:flex-row items-center gap-[30px]">
                  <!-- IMG -->
                  <div class="flex-1">
                    <img
                      src="https://plus.unsplash.com/premium_photo-1661757221486-183030ef8670?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGRvY3RvcnxlbnwwfDF8MHx8fDA%3D"
                      alt="">
                  </div>
                  <!-- INFO -->
                  <div class="flex-1 flex flex-col">
                    <!-- NAME -->
                    <h4 class="h4 mb-[10px]">Dr. Leslie Taylor</h4>
                    <!-- JOB -->
                    <div class="font-medium uppercase tracking-[2.24px] 
                      text-[#9ab4b7] mb-[20px]">Pediatrician</div>
                    <!-- DESCRIPTION -->
                    <p class="font-light mb-[26px] max-2-[320px]">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Iure cumque deserunt, quis ratione provident</p>
                    <!-- SOCIAL -->
                    <div class="flex items-center text-[30px] gap-x-5 text-accent-tertiary">
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-youtube-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-facebook-circle-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-instagram-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-pinterest-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ITEM 2-->
              <div class="flex-1 flex flex-col lg:flex-row">
                <div class="flex flex-col lg:flex-row items-center gap-[30px]">
                  <!-- IMG -->
                  <div class="flex-1">
                    <img
                      src="https://images.unsplash.com/photo-1582750433449-648ed127bb54?auto=format&fit=crop&q=60&w=500&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mzh8fGRvY3RvcnxlbnwwfHwwfHx8MA%3D%3D"
                      alt="">
                  </div>
                  <!-- INFO -->
                  <div class="flex-1 flex flex-col">
                    <!-- NAME -->
                    <h4 class="h4 mb-[10px]">Dr. Elham Ahmadi</h4>
                    <!-- JOB -->
                    <div class="font-medium uppercase tracking-[2.24px] 
                      text-[#9ab4b7] mb-[20px]">Pediatrician</div>
                    <!-- DESCRIPTION -->
                    <p class="font-light mb-[26px] max-2-[320px]">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Iure cumque deserunt, quis ratione provident</p>
                    <!-- SOCIAL -->
                    <div class="flex items-center text-[30px] gap-x-5 text-accent-tertiary">
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-youtube-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-facebook-circle-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-instagram-fill"></i>
                      </a>
                      <a href="#" class="cursor-pointer hover:text-accent transition-all">
                        <i class="ri-pinterest-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- If we need pagination -->
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </section>
</template>

<script>
    export default {
        mounted() {
            // Initialize ScrollReveal
            import('scrollreveal').then(ScrollReveal => {
            const sr = ScrollReveal.default({
                origin: 'bottom',
                distance: '30px',
                duration: 1000,
                delay: 100
            });

            sr.reveal('.team_title', {interval: 200});
            sr.reveal('.team_slider', {interval: 200});
            
            });
        }
    }
</script>

<style scoped>
/* Your scoped CSS here */
</style>
